import { render, staticRenderFns } from "./ModalGuiaTermos.vue?vue&type=template&id=21147de0&"
import script from "./ModalGuiaTermos.vue?vue&type=script&lang=js&"
export * from "./ModalGuiaTermos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports